export default "../../src/img/brand-logo.svg";